import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import * as Typos from "src/components/atoms/Typographs";
import routes from "src/constants/routes";
import { Btn, CheckboxWrapper, LinkButton } from "src/theme/Styled";
import { EVENT_EX } from "src/constants/placeholders";

const SummaryList = (props) => {
  const navigate = useNavigate();
  const [items, setItems] = useState([...props.items]);
  const [month, setMonth] = useState();
  const [showLoadMore, setShowLoadMore] = useState(false);

  useEffect(() => {
    const currentMonth = new Date().getMonth() * 30;
    (props.items || []).sort((a, b) => {
      let aDiff = (a.events.month - 1) * 30 + a.events.day - currentMonth;
      let bDiff = (b.events.month - 1) * 30 + b.events.day - currentMonth;
      aDiff < 0 ? (aDiff = 1000 + aDiff) : false;
      bDiff < 0 ? (bDiff = 1000 + bDiff) : false;
      return aDiff - bDiff;
    });
    setItems([...props.items]);
  }, [props.items]);

  const loadMore = () => {
    props.loadMore && props.loadMore();
    setShowLoadMore(true);
  };

  const filter = (evt) => {
    setMonth(evt.target.value);
    setShowLoadMore(false);
    props.filter && props.filter(evt.target.value);
  };

  const resetFilter = () => {
    setMonth("");
    setShowLoadMore(false);
    props.filter && props.filter();
  };

  const goToUser = (user) => {
    navigate(routes.ALL_USERS + "/" + user.username);
  };

  const _renderItemCell = (item, index) => {
    let date = "";
    const event = item.events;
    date = [event.month, event.day].join(".");
    return (
      <Item
        key={event._id + "-" + index}
        onClick={() => goToUser(item.friends)}
      >
        <td className="user-avatar-wrapper">
          <img src={item.friends.avatar} alt="user" />
        </td>
        <td style={{ width: "80px" }}>
          <div className="text-cell">
            <Typos.Desc>{date}</Typos.Desc>
          </div>
        </td>
        <td>
          <div className="text-cell">
            <Typos.Desc>{item.events.name}</Typos.Desc>
          </div>
        </td>
      </Item>
    );
  };

  return (
    <>
      <div>
        {!items.length ? (
          <Typos.Desc style={{ fontSize: "13px", marginBottom: "8px" }}>
            When you follow friends, their dates will be populated below{" "}
            {props.user ? (
              <LinkButton
                className="td-underline c-pointer"
                as={Link}
                to={routes.ALL_USERS}
              >
                Find friends to get started
              </LinkButton>
            ) : (
              <div
                className="td-underline c-pointer"
                onClick={props.clickEvent}
              >
                Find friends to get started
              </div>
            )}
          </Typos.Desc>
        ) : null}
      </div>
      <div className="d-flex">
        <div>
          <Typos.FLabel>Select Month</Typos.FLabel>
          <select
            style={{ width: "200px" }}
            className="d-block"
            onChange={filter}
            value={month}
          >
            <option value="" hidden></option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        {month ? (
          <Btn
            theme="no-border"
            className="with-label"
            style={{ width: "unset", marginLeft: "8px" }}
            onClick={resetFilter}
          >
            RESET FILTER
          </Btn>
        ) : null}
      </div>
      <div className="position-relative">
        {items.length ? (
          <List className="mt-2 table">
            <tbody>
              <Item>
                <td className="user-avatar-wrapper">
                  <PlusIcon
                    className="c-pointer"
                    as={Link}
                    to={routes.ALL_USERS}
                  ></PlusIcon>
                </td>
                <td style={{ width: "80px" }}>
                  <div className="text-cell">
                    <Typos.Desc
                      className="td-underline c-pointer"
                      as={Link}
                      to={routes.ALL_USERS}
                    >
                      Add Friend
                    </Typos.Desc>
                  </div>
                </td>
                <td></td>
              </Item>
              {showLoadMore
                ? items.map((item, i) => _renderItemCell(item, i))
                : (items || [])
                    .slice(0, 14)
                    .map((item, i) => _renderItemCell(item, i))}
              {items.length > 14 && !showLoadMore ? (
                <tr>
                  <td colSpan={3}>
                    <Btn
                      className="mt-2 w-fit px-4 mx-auto"
                      theme="outline"
                      onClick={loadMore}
                    >
                      SHOW MORE
                    </Btn>
                  </td>
                </tr>
              ) : null}
            </tbody>
          </List>
        ) : (
          <table>
            <tbody>
              {EVENT_EX.map((item, index) => (
                <EventItem key={index} className="placeholder-item py-2">
                  <td className="user-avatar-wrapper">
                    <div className="image-wrapper">
                      <img src={item.picture} alt="user" />
                    </div>
                  </td>
                  <td style={{ width: "80px" }}>
                    <div className="text-cell">
                      <Typos.Desc className="fake-text">
                        {item.month}.{item.day}
                      </Typos.Desc>
                    </div>
                  </td>
                  <td>
                    <div className="text-cell">
                      <Typos.Desc className="fake-text">
                        {item.event_name}
                      </Typos.Desc>
                    </div>
                  </td>
                </EventItem>
              ))}
            </tbody>
          </table>
        )}
        {month && !items.length ? (
          <EmptyListDesc>
            <Typos.ExtraInfoText>
              No results found. Please try fewer filters.
            </Typos.ExtraInfoText>
          </EmptyListDesc>
        ) : null}
      </div>
    </>
  );
};

const List = styled.table`
  td {
    text-align: left;
  }

  tbody {
    .text-cell {
      display: flex;
      align-items: center;
      height: 40px;
    }

    td {
      padding: 4px 4px;
      border-bottom: none;
    }

    tr:first-child td {
      padding-top: 3px;
    }
  }
`;
const Item = styled.tr`
  cursor: pointer;
  .user-avatar-wrapper {
    width: 58px;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  &:hover {
    background-color: #f2f2f2;
  }
`;

const PlusIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: black;
  color: white;
  position: relative;
  display: block;

  &::before {
    content: "+";
    display: block;
    position: absolute;
    top: 6px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-size: 26px;
    line-height: 1;
    font-weight: 300;
    font-family: "Assistant", sans-serif;
  }
`;

const EventItem = styled.tr`
  height: 48px;

  .user-avatar-wrapper {
    width: 58px;

    .image-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
    }

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
`;

const EmptyListDesc = styled.div`
  position: absolute;
  width: 100%;
  left: 0px;
  top: 0px;
  padding: 40px;
`;

export default SummaryList;
